import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ConsultaAPI } from "../../../../../shared/http-requests";
import DropDownSearch, { makeDataSource } from "./DropDownSearch";

/**
 *
 * @author Renan Salustiano <renan.salustiano@ter.grupomarista.org.br>
 * @param setCampus {function}
 * @returns {JSX.Element}
 * @constructor
 */
const DropDownInputCampus = ({setCampus, onChangeCampus}) => {
    const [data, setData] = useState()
    const [pagination, setPagination] = useState();
    const [loading, setLoading] = useState(false);
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const [selected, setSelected] = useState(0);

    /**
     * Busca o dado pelo id caso seja um acesso direto pela url
     */
    useEffect(() => {
        const campus  = params.get('campus');

        if(campus){
            ConsultaAPI.buscarCampusPorCodigo(campus).then((response) => {
                const { data } = response;
                if(data){

                    const config = {key: 'cod_campus', text: 'nome_campus', id: 'cod_campus'}

                    const parsedData = makeDataSource([data], config);
                    setCampus(parsedData[0])
                    setSelected(data?.cod_campus)
                    setData(parsedData);
                }
            }).catch((error) => {
                // console.log(error)
            })
        }
    }, []);

    const buscarCampus = (text = '', page= 1) => {
        setLoading(true);
        return  ConsultaAPI.buscarCampus(text, page).then((response) => {
            const { data } = response;
            if(data){
                const { results, totalPages, currentPage } = data;
                setPagination({totalPages, currentPage});
                setData(makeDataSource(results, {key: 'cod_campus', text: 'nome_campus', id: 'cod_campus'}));
            }
            setLoading(false);
        }).catch( error => {
            setLoading(false)
            // console.log(error);
        });
    }

    return (
        <DropDownSearch
            placeholder="Selecione um campus"
            value={selected}
            loading={loading}
            customFilter
            data={data}
            onChange={buscarCampus}
            onSelect={(item) => {
                setCampus(item)
            }}
            pagination={pagination}
        />
    )
}

export default DropDownInputCampus;
